const initialState = {
  active: false,
  title: "",
  body: "",
  resolve: null,
  reject: null,
  note_dialog: false,
  note: "",
  ligth: true,
};

const state = Object.assign({}, initialState);

const mutations = {
  ACTIVATE: (state, payload) => {
    Object.assign(state, payload);
  },
  DEACTIVATE: (state) => {
    state = Object.assign(state, initialState);
  },
};

const actions = {
  ask: ({ commit }, { title, body, note_dialog, note, ligth }) => {
    return new Promise((resolve, reject) => {
      if (note_dialog === "undefined") note_dialog = false;
      commit("ACTIVATE", {
        active: true,
        title,
        ligth,
        body,
        note_dialog,
        note,
        resolve,
        reject,
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
